module.exports = __webpack_public_path__ + "assets/coupon-orange-3a8081.svg";